export const SUCCESS_CODE = 'SUCC-0000'
export const REPEAT_CODE = 'REPE-0000'
export const FAIL_CODE = 'FAILURE-0001'
export const ERROR_CODE = 400
export const FAIL_EXCHANGE = 'PMALL-0001'
// 3分钟内不能发送验证码
export const REPEAT_VERIFICATION_CODE = 'FAILURE-0004'



// WEBPACK FOOTER //
// ./src/constants/ReturnCodesConstants.js